/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import classname from "classnames";
import { get, isEmpty } from "lodash";
import {
  getExistId,
  getExistMobile,
  postSignUpUser,
  postUsersCert,
  postUsersCertVerify,
} from "../../../apis/users";
import useForm from "../../../hooks/useForm";
import { enterOnlyNumber } from "../../../utils/number";
import { useHistory } from "react-router";
import SVG from "react-inlinesvg";
import successIcon from "../../../assets/images/icon/success-checked.svg";
import systemAlert from "../../../utils/systemAlert";
import { restoreMobile } from "../../../utils/validator/mobile";
import Button from "../../../components/Button";
import Timer from "../../../components/Timer";
import { useDispatch } from "react-redux";
import { loginUser } from "../../../store/actions";
import { getPartnerByCode } from "../../../apis/partner/partner";
import { getCompnayNum, getReferrer, getThroughTaxCompanyCode } from "../../../utils/storage";

const SignUp = (props) => {
  const history = useHistory();
  const [focus, setFoucs] = useState({
    id: false,
    password: false,
    name: false,
    email: false,
    memo: false,
    mobile: false,
  });
  const [taxCompnay, setTaxCompnay] = useState(null)

  const _setTaxCompnay = async (code) => {
    const company = await getPartnerByCode(code)
    if (company) setTaxCompnay(company)
  }

  // 서비스 이용약관 동의 / 개인정보처리방침 동의
  const [isAgreeService, setIsAgreeService] = useState(false);
  const [isAgreePrivacy, setIsAgreePrivacy] = useState(false);

  // 아이디 중복체크
  const [isExistId, setIsExistId] = useState(false);
  const [isFirst, setIsFirst] = useState(true);
  // 비밀번호 하이드
  const [isHidePassword, setIsHidePassword] = useState(true);
  // 인증 시간
  const [isTimer, setIsTimer] = useState(false)
  const [isCertSuccess, setCertIsSuccess] = useState(false)

  const dispatch = useDispatch();
  const handleOnFocus = (e) => {
    const { name } = e.target;
    setFoucs({
      ...focus,
      [name]: true,
    });
  };

  const handleOnBlur = (e) => {
    const { name } = e.target;
    if (name === "id") {
      handleCheckId();
    }
    setFoucs({
      ...focus,
      [name]: false,
    });
  };


  const validate = ({ id, password, pwdCheck, name, email, mobile }) => {
    let errors = {};
    const regPwd = /^.*(?=^.{8,30}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).*$/;
    const regEmail = /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/;
    if (!id) {
      errors.id = "아이디는 필수입니다.";
    }

    if (!password) {
      errors.password = "비밀번호는 필수입니다.";
    } else if (!regPwd.test(password)) {
      errors.password = "영문자, 숫자, 특수문자 조합 8~30자로 설정해주세요";
    }

    if (!pwdCheck) {
      errors.pwdCheck = "비밀번호 확인은 필수입니다.";
    } else if (form.password !== form.pwdCheck) {
      errors.pwdCheck = "비밀번호가 동일하지 않습니다.";
    }

    if (!name) {
      errors.name = "이름은 필수입니다.";
    }

    if (!email) {
      errors.email = "이메일은 필수입니다.";
    } else if (!regEmail.test(form.email)) {
      errors.email = "올바른 이메일 주소를 입력해주세요.";
    }

    if (!mobile) {
      errors.mobile = "휴대폰번호는 필수입니다.";
    }

    return errors;
  };

  const submit = (form) => {
    // console.log(form);
    // if (!isAgree) {
    //   systemAlert("개인 정보 수집에 동의해 주세요.")
    //   return;
    // }
    if (!form.verifyToken) {
      systemAlert("휴대폰번호를 인증해 주세요.")
      return;
    }
    if (form.id.includes(' ')) {
      systemAlert("아이디에 공백은 포함 할 수 없습니다.")
      return;
    }
    delete form.pwdCheck;
    delete form.verifyCode;
    const data = {
      ...form,
      accessPath: getReferrer()
    };

    postSignUpUser(data)
      .then((res) => {

        // history.push("/sign-up-complete");

        systemAlert(`${form.name}님 가입을 축하합니다.`, {
          buttons: [
            {
              label: '확인',
              onClick: () => {
                reset();
                dispatch(loginUser({
                  id: data.id,
                  password: data.password,
                }, history))

              }
            }
          ]
        })

      })
      .catch((err) => {
        systemAlert(get(err, "response.data.message"))
      });
  }

  const {
    form,
    errors,
    handleOnChange,
    handleSubmit,
    reset,
    setValidateFields
  } = useForm({
    id: "",
    verifyToken: '', // 인증 토큰
    password: "",
    pwdCheck: "",
    name: "",
    email: "",
    memo: "",
    mobile: "",
    verifyCode: "",
  },
    submit,
    validate,
  );

  useEffect(() => {
    setValidateFields([
      { key: 'id', type: 'inpyut', },
      { key: 'verifyToken', type: 'inpyut', },
      { key: 'password', type: 'inpyut', },
      { key: 'pwdCheck', type: 'inpyut', },
      { key: 'name', type: 'inpyut', },
      { key: 'email', type: 'inpyut', validators: ['email'] },
      { key: 'memo', type: 'inpyut' },
      { key: 'mobile', type: 'inpyut', validators: ['mobile'] },
      { key: 'verifyCode', type: 'inpyut', },
    ])
  }, []);

  useEffect(() => {
    if (isEmpty(form.id)) {
      setIsFirst(true);
    }
  }, [form.id]);

  // 아이디 중복체크
  const handleCheckId = () => {
    if (!form.id) return;

    getExistId(form.id).then((res) => {
      setIsFirst(false);
      setIsExistId(res.data.exist);
    });
  };

  // 인증번호 발송
  const handleSendCert = (e) => {
    e.preventDefault();
    if (!form.mobile) return;
    const mobile = restoreMobile(form.mobile)
    getExistMobile(mobile).then((res) => {
      if (!get(res, "data.exist")) {
        postUsersCert({ mobile })
          .then((res) => {
            setCertIsSuccess(false)
            setIsTimer(true)
          })
          .catch((err) => {
            systemAlert("인증번호 요청에 실패했습니다.")
          });
      } else {
        systemAlert("등록된 휴대폰번호 입니다.")
      }
    });
  };

  // 인증확인 체크
  const handleCheckCert = (e) => {
    e.preventDefault();
    if (!form.verifyCode) return;

    const data = {
      mobile: restoreMobile(form.mobile),
      verifyCode: form.verifyCode,
    };
    postUsersCertVerify(data)
      .then((res) => {
        setCertIsSuccess(true)
        setIsTimer(false)
        handleOnChange({
          verifyToken: get(res, "data.verifyToken")
        })
        systemAlert("인증에 성공하였습니다.")
      });
  };

  const openTerm = (type) => {
    const popupX = document.body.offsetWidth / 2 - 500 / 2;
    const popupY = window.screen.height / 2 - 600 / 2;
    window.open(
      `https://yds.ai/term/${type}?layout=hide`,
      `${type}`,
      `width=500,height=600, left=${popupX}, top=${popupY}`
    );
  };

  const timerExpiredAction = () => {
    setIsTimer(false)
  }

  useEffect(() => {
    getCompnayNum()
    if (getThroughTaxCompanyCode()) {
      _setTaxCompnay(getThroughTaxCompanyCode())
    }
  }, []);

  return (
    <div className="Layout auth-wrap">
      <div className="sign-up">
        {get(taxCompnay, 'name', '') ?
          <h1 className="has-tax-comapny-logo">
            {get(taxCompnay, 'logoFile.fileUrl') ?
              <>
                <img src={get(taxCompnay, 'logoFile.fileUrl')} className="tax-comapny-logo" alt={get(taxCompnay, 'name')} />
                <small>세무사 {get(taxCompnay, 'ceoName', '')}</small>
              </>
              :
              <>
                <label>{get(taxCompnay, 'name', '')}</label>
                <small>세무사 {get(taxCompnay, 'ceoName', '')}</small>
              </>
            }
          </h1>
          :
          <h1>회원가입</h1>
        }

        <div className="sign-up-form">
          <div
            className={classname("form-info-wrap", {
              focus: get(focus, "id"),
            })}
          >
            <label>아이디</label>
            <div className="input-wrap">
              <input
                name="id"
                placeholder="아이디를 입력해주세요"
                value={form.id}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
              />
              {!isFirst && form.id && !isExistId && (
                <span className="icon">
                  <SVG src={successIcon} stroke="#4DDDBA" />
                </span>
              )}
              {!isFirst &&
                form.id &&
                (!isExistId ? (
                  <p className="validation-msg success">
                    사용할 수 있는 아이디입니다
                  </p>
                ) : (
                  <p className="validation-msg error">
                    이미 사용중인 아이디입니다
                  </p>
                ))}
              {errors.id && (
                <p className="validation-msg error">{errors.id}</p>
              )}
            </div>
          </div>
          <div className="divider" />
          <div
            className={classname("form-info-wrap", {
              focus: get(focus, "password") || get(focus, "pwdCheck"),
            })}
          >
            <label>비밀번호</label>
            <div className="input-wrap">
              <input
                name="password"
                type={isHidePassword ? "password" : "text"}
                placeholder="비밀번호를 입력해주세요"
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
              />
              <span className="icon">
                <i
                  className={`mdi ${isHidePassword ? "mdi-eye" : "mdi-eye-off"
                    } font-size-24`}
                  onClick={() => setIsHidePassword(!isHidePassword)}
                />
              </span>

              {errors.password && (
                <p className="validation-msg error">{errors.password}</p>
              )}
            </div>
            <div className="input-wrap repeat">
              <input
                name="pwdCheck"
                type={isHidePassword ? "password" : "text"}
                placeholder="비밀번호를 다시 입력해주세요"
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
              />
              {errors.pwdCheck && (
                <p className="validation-msg error">{errors.pwdCheck}</p>
              )}
            </div>
          </div>
          <div className="divider" />
          <div
            className={classname("form-info-wrap", {
              focus: get(focus, "name"),
            })}
          >
            <label>이름</label>
            <div className="input-wrap">
              <input
                name="name"
                placeholder="이름을 입력해주세요"
                value={form.name}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
              />
              {errors.name && (
                <p className="validation-msg error">{errors.name}</p>
              )}
            </div>
          </div>
          <div className="divider" />
          <div
            className={classname("form-info-wrap", {
              focus: get(focus, "email"),
            })}
          >
            <label>이메일</label>
            <div className="input-wrap">
              <input
                name="email"
                placeholder="이메일을 입력해주세요"
                value={form.email}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
              />
              {errors.email && (
                <p className="validation-msg error">{errors.email}</p>
              )}
            </div>
          </div>
          {/*
            <div className="divider" />
            <div
              className={classname("form-info-wrap", {
                focus: get(focus, "memo"),
              })}
            >
              <label>
                메모<span className="optional-label">(선택)</span>
              </label>
              <div className="input-wrap">
                <input
                  name="memo"
                  placeholder="남기실 메모가 있으면 입력해주세요"
                  value={form.memo}
                  onChange={handleOnChange}
                  onFocus={handleOnFocus}
                  onBlur={handleOnBlur}
                />
              </div>
            </div> 
            */}
          <div className="divider" />
          <div
            className={classname("form-info-wrap", {
              focus: get(focus, "mobile") || get(focus, "verifyCode"),
            })}
          >
            <label>휴대폰번호</label>
            <div className="input-wrap">
              <input
                name="mobile"
                placeholder="휴대폰번호를 입력해주세요"
                value={form.mobile}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                onKeyDown={enterOnlyNumber}
              />
              {errors.mobile && (
                <p className="validation-msg error">{errors.mobile}</p>
              )}
              <Button
                label="인증요청"
                size="sm"
                color="line"
                className="cert-button"
                onClick={handleSendCert}
                disabled={!form.mobile}
              />
              {isTimer &&
                <Timer isSuccess={isCertSuccess} expireAction={timerExpiredAction} />
              }
            </div>
            <div className="input-wrap repeat">
              <input
                name="verifyCode"
                placeholder="인증번호를 입력해주세요"
                value={form.verifyCode}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                onKeyDown={enterOnlyNumber}
              />
              {isCertSuccess && (
                <p className="cert-success-text">인증되었습니다</p>
              )}
              <div className="btn-wrap clear">
                <Button
                  label="인증확인"
                  size="sm"
                  color="line"
                  className="cert-button"
                  onClick={handleCheckCert}
                  disabled={!form.verifyCode}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="terms-wrap">
          <label>
            <input
              type="checkbox"
              checked={isAgreeService}
              onChange={() => setIsAgreeService(!isAgreeService)}
            />
            이용약관에 동의합니다.
          </label>
          <div className="terms-view">
            <a onClick={() => openTerm('service')}>
              서비스이용약관
            </a>
          </div>
        </div>
        <div className="terms-wrap">
          <label>
            <input
              type="checkbox"
              checked={isAgreePrivacy}
              onChange={() => setIsAgreePrivacy(!isAgreePrivacy)}
            />
            개인정보처리방침에 동의합니다.
          </label>
          <div className="terms-view">
            <a onClick={() => openTerm('privacy')}>
              개인정보처리방침
            </a>
          </div>
        </div>
        <button onClick={handleSubmit} className="sign-up-btn" disabled={!isAgreeService || !isAgreePrivacy}>
          회원가입
        </button>
        <div className="copyright">
          Copyright&nbsp;©&nbsp;2021&nbsp;YDS&nbsp;All&nbsp;rights&nbsp;reserved.
        </div>
      </div>
    </div>
  );
};

export default SignUp;
